import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../../components/Modal/ModalContext';
import { TripLogInterface } from '../../../models/dashboard/trip-log/trip-log';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useTripLog = () => {
  const modalContext = useContext(ModalContext);
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onTripLogError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while logging the trip.',
    );
  };

  const onTripLogSuccess = (callbackFn?: () => void) => ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success('Trip logged successfully.');
    modalContext?.setShowModal(false);
    if (callbackFn) {
      callbackFn();
    }
  };

  const tripLog = (tripLogs: TripLogInterface[], callbackFn?: () => void) => {
    const completedTripLogs = tripLogs.map((tripLogData) => ({ ...tripLogData, isCompleted: true }));
    const url: HttpConfig = {
      url: 'api/v1/trip-logs',
      method: 'post',
      data: completedTripLogs,
    };
    request(url, onTripLogSuccess(callbackFn), setLoading, onTripLogError);
  };

  return { tripLog, loading };
};

export default useTripLog;
